module.exports = __webpack_public_path__ + "static/media/CIOB.c632fea3.png";